module.exports = __webpack_public_path__ + "img/invite-spin.173c1836.gif";